export const walls = [
  {
    id: 1,
    start: 'Abbotsford',
    end: 'Brushgrove',
    start_letters: 'ab',
    end_letters: 'br',
  },
  {
    id: 2,
    start: 'Bucca',
    end: 'Dalgety',
    start_letters: 'bu',
    end_letters: 'da',
  },
  {
    id: 3,
    start: 'Dalmorton',
    end: 'Greenwich Park',
    start_letters: 'da',
    end_letters: 'gr',
  },
  {
    id: 4,
    start: 'Grenfell',
    end: 'Lidcombe',
    start_letters: 'gr',
    end_letters: 'li',
  },
  {
    id: 5,
    start: 'Liddell',
    end: 'Narrabeen',
    start_letters: 'li',
    end_letters: 'na',
  },
  {
    id: 6,
    start: 'Narrabri',
    end: 'Rugby',
    start_letters: 'na',
    end_letters: 'ru',
  },
  {
    id: 7,
    start: 'Rundle',
    end: 'Tyalgum',
    start_letters: 'ru',
    end_letters: 'ty',
  },
  {
    id: 8,
    start: 'Tyndale',
    end: 'Zetland',
    start_letters: 'ty',
    end_letters: 'ze',
  },
  {
    id: 9,
    start: 'Orakau',
    end: 'Dili',
    start_letters: 'Orakau',
    end_letters: 'Dili',
  }
];